import { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import FileUpload from '../../common/form/elements/file-upload';
import FileUploadFileList from '../../common/form/elements/file-upload-file-list';
import RequiredInput from '../../common/form/elements/required-input';

class NumberOfPacksSold extends Component {
  handleFileUpload = (file) => {
    const { model, dispatch } = this.props;

    dispatch(actions.push(
      `${model}.proof_of_purchases_attributes`,
      { [Date.now()]: { persisted: false, proof_of_purchase: file } }
    ));
  };

  render() {
    const { model, formData, products } = this.props;

    return (
      <div>
        <Row>
          <Col md={12}>
            Number of packs sold*
          </Col>
        </Row>
        {products && products.map((product, index) => (
          <Row className="product" key={index}>
            <Col md={6} xs={12} className="text">{product.label}</Col>
            <Col md={6} xs={12}>
              <RequiredInput
                model={`${model}.products.${product.value}`}
                type="number"
                placeholder="Number of packs sold"
                min={0}
                step={1}
                positive={false}
              />
            </Col>
          </Row>
        ))}
        <Row>
          <Col md={12}>
            <div className="space-text">
              Your rep has indicated you will provide
              {' '}
              <span className="bold-text">
                Evidence
              </span>
              {' '}
              to support your submission.
              Please upload your documentation below, note you can upload multiple documents.
            </div>
            <FileUpload
              label=""
              model={`${model}.proof_of_purchases`}
              showFileNameInTextField={false}
              onFileLoaded={this.handleFileUpload}
              multi
              required
            />
            <div style={{ marginBottom: '20px' }}>
              <FileUploadFileList
                data={formData.proof_of_purchases_attributes}
                model={`${model}.proof_of_purchases_attributes`}
                fileName={'proof_of_purchase'}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formData: state.deep.autoEposPriceItPlus
});

export default connect(mapStateToProps)(NumberOfPacksSold);
